// Client-side password rule for signup and the reset handler. Firebase still
// enforces its own minimum until the project policy is raised; this check
// runs first so a short password never leaves the browser.

export const MIN_PASSWORD_LENGTH = 8;
export const MAX_PASSWORD_LENGTH = 4096;

export const PASSWORD_TOO_SHORT = "Use at least 8 characters.";
export const PASSWORD_HINT = "At least 8 characters.";
export const PASSWORDS_DONT_MATCH = "Passwords don't match.";
export const RESET_EMAIL_INVALID = "Enter a valid email address.";
export const RESET_UNREACHABLE =
  "Can't reach the server. Check your connection and try again.";

export function passwordTooShort(password: string): boolean {
  return password.length < MIN_PASSWORD_LENGTH;
}

/** Mismatch wins over length so a typo is not described as a policy failure. */
export function passwordProblem(
  password: string,
  confirm: string,
): string | null {
  if (password !== confirm) return PASSWORDS_DONT_MATCH;
  if (passwordTooShort(password)) return PASSWORD_TOO_SHORT;
  return null;
}

/** First character of the local part, then the domain. Never the full address. */
export function maskEmail(email: string): string {
  const trimmed = email.trim();
  const at = trimmed.indexOf("@");
  if (at <= 0 || at !== trimmed.lastIndexOf("@")) return "•••";
  const domain = trimmed.slice(at + 1);
  if (!domain || domain.includes(" ")) return "•••";
  return `${trimmed[0]}•••@${domain}`;
}

export function emailLooksValid(value: string): boolean {
  const email = value.trim();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
